// @flow
import WebComponent from '../webComponents/WebComponent';

const fragments = {
  TARGET: '[data-prevent-double-click="true"]',
};

class PreventDoubleClickHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  didMount() {
      this.targetElements = this.element.querySelectorAll(fragments.TARGET);
    Array.from(this.targetElements).forEach(target => {
      target.addEventListener('click', (event) => this.handleClick(event, target));
    });
  }

  handleClick(e, target) {
    const {
      applyToAll,
    } = this.props;

    if (applyToAll) {
      Array.from(this.targetElements).forEach(target => {
        target.style.pointerEvents = 'none';
      });
    }
    else {
      target.style.pointerEvents = 'none';
    }
  }
}

PreventDoubleClickHandler.defaultProps = {
  applyToAll: false // by default applies only to clicked element
}

export default PreventDoubleClickHandler;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/PreventDoubleClickHandler.js